import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import NotFoundPage from '../pages/NotFoundPage';

const SUPPORTED_LANGS = ['ru', 'uz'];

const LanguageRoute = ({ children }) => {
  const { lang } = useParams();
  const { changeLanguage } = useLanguage();
  const isValidLang = SUPPORTED_LANGS.includes(lang);

  useEffect(() => {
    if (isValidLang) {
      changeLanguage(lang);
    }
  }, [lang, isValidLang, changeLanguage]);

  if (!isValidLang) {
    return <NotFoundPage />;
  }

  return children;
};

export default LanguageRoute;
